// KOM: mark "Talla" filter block without :has()
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('facets-drawer.drawer');
  if (!drawer) return;

  // Find any container that contains the talla inputs and mark its closest details/section
  drawer.querySelectorAll('input[name="filter.v.option.talla"]').forEach((inp) => {
    const details = inp.closest('details') || inp.closest('.facets__item') || inp.closest('section') || inp.closest('div');
    if (details) details.classList.add('is-size');
  });
});